import AuthenticationHelper from "./OIDCManager";
import axios, { AxiosRequestConfig, AxiosRequestTransformer } from "axios";
import i18n from "../i18n";

export const apiCallWithAuth = async (
    url: string,
    method: string = "get",
    config: Object = {},
    requestConfig?: AxiosRequestConfig<Object>
) => {
    const auth = new AuthenticationHelper();

    const isPlainObject = (v: unknown) => Object.prototype.toString.call(v) === '[object Object]';

    const dateTransformer: AxiosRequestTransformer = (data) => {
        if (data instanceof Date) {
            // Conversion au format suédois, très proche du format ISO sans la conversion automatique en UTC
            let swedenFormat = data.toLocaleString('sv');
            return swedenFormat.replace(' ', 'T').concat('.000Z');
        }

        if (isPlainObject(data)) {
            return Object.fromEntries(
                Object.entries(data).map(([key, val]) => [key, dateTransformer(val)])
            );
        }

        return data;
    };

    const defaultReqConfig: AxiosRequestConfig<Object> = {
        ...requestConfig
    }

    //  transformRequest: [ dateTransformer ].concat(axios.defaults.transformRequest)

    // Vérification de l'expiration du token avant l'appel API
    const userInfo = await auth.getUserInfo();

    if (userInfo?.expired) {
        console.log("Token expiré - tentative de refresh...");
        try {
            await auth.silentRenew();
        } catch (error) {
            console.error("Refresh token échoué - déconnexion");
            auth.logout();
            throw new Error("Session expirée");
        }
    }

    return auth
        .getAccessToken()
        .then(async (userToken: string) => {
            if (userToken == undefined) {
                return (await axios({ url, method: method.toLowerCase(), ...config }))
                    .data;
            } else {
                //Add access token to request headers

                axios.defaults.headers.common["Authorization"] = `Bearer ${userToken}`;
                axios.defaults.headers.common["Accept-Language"] = i18n.global.locale;

                try {
                    switch (method.toLowerCase()) {
                        case "get":
                            return await axios.get(url, config);
                        case "post":
                            return await axios.post(url, config, defaultReqConfig);
                        case "put":
                            return await axios.put(url, config, defaultReqConfig);
                        case "patch":
                            return await axios.patch(url, config, defaultReqConfig);
                        case "batchdelete":
                            return await axios.delete(url, {data: config,...defaultReqConfig,headers: { 'Content-Type': 'application/json',...defaultReqConfig.headers }});
                        default:
                            return await axios({ url, method: method.toLowerCase(), ...config });
                    }
                } catch (e: any) {
                    if (e.response != undefined && e.response.status == 400) {
                        console.log("Catch erreur axios : " + JSON.stringify(e.response));
                        return e.response;
                    } else {
                        throw e;
                    }
                }
            }
        })
        .catch((e) => {
            throw e;
        });
};
